import { render, staticRenderFns } from "./AppSocialLanding.vue?vue&type=template&id=79a640e2&"
import script from "./AppSocialLanding.vue?vue&type=script&lang=js&"
export * from "./AppSocialLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports